var _style, _circle, _polyline, _line, _line2, _line3, _line4, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22,
    cy: 22,
    r: 7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12,25 4,25 4,7 28,7 28,13 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17.9,
    y1: 16.3,
    x2: 24,
    y2: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 8,
    y1: 11,
    x2: 16,
    y2: 18
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13.7,
    y1: 16,
    x2: 8,
    y2: 21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22,
    y1: 26,
    x2: 22,
    y2: 19
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "25,22.1 22,19 19,22.1 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushEmailIcon);
export default __webpack_public_path__ + "static/media/push-email-icon.e42e5e49789274bbd9d09d4b7f9f9bf7.svg";
export { ForwardRef as ReactComponent };